/**
 * get localStorage item, acts the same as localStorage.getItem, implemented for parity with setLocalStorage
 * @param item
 * @returns
 */
export function getLocalStorage(item: string) {
  return localStorage.getItem(item);
}
